// Mapa internal sticker id -> nombre del jugador.
// Fuente: Football Cartophilic Info Exchange (Panini WC26 checklist),
// cross-verificado contra checklistinsider.com en stars.
// Cobertura: slots 2-12 y 14-20 de los 48 paises (912 entradas).
// Slots 1 (Escudo) y 13 (Foto grupal) NO van aqui; el catalogo los hardcodea.
// Nota Japon: se usa prefijo 'JAP' (matching countries.ts), no 'JPN'.
// Nota CZE16: id interno 'CZE16' (displayCode visible es 'Che16').

export const playerNames: Record<string, string> = {
  // Algeria
  ALG2: 'Alexis Guendouz',
  ALG3: 'Ramy Bensebaini',
  ALG4: 'Youcef Atal',
  ALG5: 'Rayan Aït-Nouri',
  ALG6: 'Mohamed Amine Tougai',
  ALG7: 'Aïssa Mandi',
  ALG8: 'Ismael Bennacer',
  ALG9: 'Houssem Aouar',
  ALG10: 'Hicham Boudaoui',
  ALG11: 'Ramiz Zerrouki',
  ALG12: 'Nabil Bentaleb',
  ALG14: 'Farès Chaibi',
  ALG15: 'Riyad Mahrez',
  ALG16: 'Saïd Benrahma',
  ALG17: 'Anis Hadj Moussa',
  ALG18: 'Amine Gouiri',
  ALG19: 'Baghdad Bounedjah',
  ALG20: 'Mohammed Amoura',

  // Argentina
  ARG2: 'Emiliano Martínez',
  ARG3: 'Nahuel Molina',
  ARG4: 'Cristian Romero',
  ARG5: 'Nicolás Otamendi',
  ARG6: 'Nicolás Tagliafico',
  ARG7: 'Leonardo Balerdi',
  ARG8: 'Enzo Fernández',
  ARG9: 'Alexis Mac Allister',
  ARG10: 'Rodrigo De Paul',
  ARG11: 'Exequiel Palacios',
  ARG12: 'Leandro Paredes',
  ARG14: 'Nico Paz',
  ARG15: 'Franco Mastantuono',
  ARG16: 'Nico González',
  ARG17: 'Lionel Messi',
  ARG18: 'Lautaro Martínez',
  ARG19: 'Julián Álvarez',
  ARG20: 'Giuliano Simeone',

  // Australia
  AUS2: 'Mathew Ryan',
  AUS3: 'Joe Gauci',
  AUS4: 'Harry Souttar',
  AUS5: 'Alessandro Circati',
  AUS6: 'Jordan Bos',
  AUS7: 'Aziz Behich',
  AUS8: 'Cameron Burgess',
  AUS9: 'Lewis Miller',
  AUS10: 'Milos Degenek',
  AUS11: 'Jackson Irvine',
  AUS12: 'Riley McGree',
  AUS14: 'Aiden O\'Neill',
  AUS15: 'Connor Metcalfe',
  AUS16: 'Patrick Yazbek',
  AUS17: 'Craig Goodwin',
  AUS18: 'Kusini Yengi',
  AUS19: 'Nestory Irankunda',
  AUS20: 'Mohamed Touré',

  // Austria
  AUT2: 'Alexander Schlager',
  AUT3: 'Patrick Pentz',
  AUT4: 'David Alaba',
  AUT5: 'Kevin Danso',
  AUT6: 'Philipp Lienhart',
  AUT7: 'Stefan Posch',
  AUT8: 'Phillipp Mwene',
  AUT9: 'Alexander Prass',
  AUT10: 'Xaver Schlager',
  AUT11: 'Marcel Sabitzer',
  AUT12: 'Konrad Laimer',
  AUT14: 'Florian Grillitsch',
  AUT15: 'Nicolas Seiwald',
  AUT16: 'Romano Schmid',
  AUT17: 'Patrick Wimmer',
  AUT18: 'Christoph Baumgartner',
  AUT19: 'Michael Gregoritsch',
  AUT20: 'Marko Arnautović',

  // Belgium
  BEL2: 'Thibaut Courtois',
  BEL3: 'Arthur Theate',
  BEL4: 'Timothy Castagne',
  BEL5: 'Zeno Debast',
  BEL6: 'Brandon Mechele',
  BEL7: 'Maxim De Cuyper',
  BEL8: 'Thomas Meunier',
  BEL9: 'Youri Tielemans',
  BEL10: 'Amadou Onana',
  BEL11: 'Nicolas Raskin',
  BEL12: 'Alexis Saelemaekers',
  BEL14: 'Hans Vanaken',
  BEL15: 'Kevin De Bruyne',
  BEL16: 'Jérémy Doku',
  BEL17: 'Charles De Ketelaere',
  BEL18: 'Leandro Trossard',
  BEL19: 'Loïs Openda',
  BEL20: 'Romelu Lukaku',

  // Bosnia and Herzegovina
  BIH2: 'Nikola Vasilj',
  BIH3: 'Amer Dedić',
  BIH4: 'Sead Kolašinac',
  BIH5: 'Tarik Muharemović',
  BIH6: 'Nihad Mujakić',
  BIH7: 'Nikola Katić',
  BIH8: 'Amir Hadžiahmetović',
  BIH9: 'Benjamin Tahirović',
  BIH10: 'Armin Gigović',
  BIH11: 'Ivan Šunjić',
  BIH12: 'Ivan Bašić',
  BIH14: 'Dženis Burnić',
  BIH15: 'Esmir Bajraktarević',
  BIH16: 'Amar Memić',
  BIH17: 'Ermedin Demirović',
  BIH18: 'Edin Džeko',
  BIH19: 'Samed Baždar',
  BIH20: 'Haris Tabaković',

  // Brazil
  BRA2: 'Alisson',
  BRA3: 'Bento',
  BRA4: 'Marquinhos',
  BRA5: 'Éder Militão',
  BRA6: 'Gabriel Magalhães',
  BRA7: 'Danilo',
  BRA8: 'Wesley',
  BRA9: 'Lucas Paquetá',
  BRA10: 'Casemiro',
  BRA11: 'Bruno Guimarães',
  BRA12: 'Luiz Henrique',
  BRA14: 'Vinicius Júnior',
  BRA15: 'Rodrygo',
  BRA16: 'João Pedro',
  BRA17: 'Matheus Cunha',
  BRA18: 'Gabriel Martinelli',
  BRA19: 'Raphinha',
  BRA20: 'Estêvão',

  // Canada
  CAN2: 'Dayne St. Clair',
  CAN3: 'Alphonso Davies',
  CAN4: 'Alistair Johnston',
  CAN5: 'Sam Adekugbe',
  CAN6: 'Richie Laryea',
  CAN7: 'Derek Cornelius',
  CAN8: 'Moïse Bombito',
  CAN9: 'Kamal Miller',
  CAN10: 'Stephen Eustáquio',
  CAN11: 'Ismaël Koné',
  CAN12: 'Jonathan Osorio',
  CAN14: 'Jacob Shaffelburg',
  CAN15: 'Mathieu Choinière',
  CAN16: 'Niko Sigur',
  CAN17: 'Tajon Buchanan',
  CAN18: 'Liam Millar',
  CAN19: 'Cyle Larin',
  CAN20: 'Jonathan David',

  // Cape Verde
  CPV2: 'Vozinha',
  CPV3: 'Logan Costa',
  CPV4: 'Pico',
  CPV5: 'Diney',
  CPV6: 'Steven Moreira',
  CPV7: 'Wagner Pina',
  CPV8: 'João Paulo',
  CPV9: 'Yannick Semedo',
  CPV10: 'Kevin Pina',
  CPV11: 'Patrick Andrade',
  CPV12: 'Jamiro Monteiro',
  CPV14: 'Deroy Duarte',
  CPV15: 'Garry Rodrigues',
  CPV16: 'Jovane Cabral',
  CPV17: 'Ryan Mendes',
  CPV18: 'Dailon Livramento',
  CPV19: 'Willy Semedo',
  CPV20: 'Bebé',

  // Colombia
  COL2: 'Camilo Vargas',
  COL3: 'David Ospina',
  COL4: 'Dávinson Sánchez',
  COL5: 'Yerry Mina',
  COL6: 'Daniel Muñoz',
  COL7: 'Johan Mojica',
  COL8: 'Jhon Lucumí',
  COL9: 'Santiago Arias',
  COL10: 'Jefferson Lerma',
  COL11: 'Kevin Castaño',
  COL12: 'Richard Ríos',
  COL14: 'James Rodríguez',
  COL15: 'Juan Fernando Quintero',
  COL16: 'Jorge Carrascal',
  COL17: 'Jhon Arias',
  COL18: 'Jhon Córdoba',
  COL19: 'Luis Suárez',
  COL20: 'Luis Díaz',

  // DR Congo
  COD2: 'Lionel Mpasi',
  COD3: 'Aaron Wan-Bissaka',
  COD4: 'Axel Tuanzebe',
  COD5: 'Arthur Masuaku',
  COD6: 'Chancel Mbemba',
  COD7: 'Joris Kayembe',
  COD8: 'Charles Pickel',
  COD9: 'Ngal\'ayel Mukau',
  COD10: 'Edo Kayembe',
  COD11: 'Samuel Moutoussamy',
  COD12: 'Noah Sadiki',
  COD14: 'Théo Bongonda',
  COD15: 'Meschak Elia',
  COD16: 'Yoane Wissa',
  COD17: 'Brian Cipenga',
  COD18: 'Fiston Mayele',
  COD19: 'Cédric Bakambu',
  COD20: 'Nathanaël Mbuku',

  // Croatia
  CRO2: 'Dominik Livaković',
  CRO3: 'Duje Ćaleta-Car',
  CRO4: 'Joško Gvardiol',
  CRO5: 'Josip Stanišić',
  CRO6: 'Luka Vušković',
  CRO7: 'Josip Sutalo',
  CRO8: 'Kristijan Jakić',
  CRO9: 'Luka Modrić',
  CRO10: 'Mateo Kovačić',
  CRO11: 'Martin Baturina',
  CRO12: 'Lovro Majer',
  CRO14: 'Mario Pašalić',
  CRO15: 'Petar Sučić',
  CRO16: 'Ivan Perišić',
  CRO17: 'Marco Pašalić',
  CRO18: 'Ante Budimir',
  CRO19: 'Andrej Kramarić',
  CRO20: 'Franjo Ivanović',

  // Curacao
  CUW2: 'Eloy Room',
  CUW3: 'Armando Obispo',
  CUW4: 'Sherel Floranus',
  CUW5: 'Jurien Gaari',
  CUW6: 'Joshua Brenet',
  CUW7: 'Roshon van Eijma',
  CUW8: 'Shurandy Sambo',
  CUW9: 'Livano Comenencia',
  CUW10: 'Godfried Roemeratoe',
  CUW11: 'Juninho Bacuna',
  CUW12: 'Leandro Bacuna',
  CUW14: 'Tahith Chong',
  CUW15: 'Kenji Gorré',
  CUW16: 'Jearl Margaritha',
  CUW17: 'Jürgen Locadia',
  CUW18: 'Jeremy Antonisse',
  CUW19: 'Gervane Kastaneer',
  CUW20: 'Sontje Hansen',

  // Czech Republic
  CZE2: 'Matěj Kovář',
  CZE3: 'Jindřich Staněk',
  CZE4: 'Ladislav Krejčí',
  CZE5: 'Vladimír Coufal',
  CZE6: 'Jaroslav Zelený',
  CZE7: 'Tomáš Holeš',
  CZE8: 'David Zima',
  CZE9: 'Michal Sadílek',
  CZE10: 'Lukáš Provod',
  CZE11: 'Lukáš Červ',
  CZE12: 'Tomáš Souček',
  CZE14: 'Pavel Šulc',
  CZE15: 'Matěj Vydra',
  CZE16: 'Vasil Kušej',
  CZE17: 'Tomáš Chorý',
  CZE18: 'Václav Černý',
  CZE19: 'Adam Hložek',
  CZE20: 'Patrik Schick',

  // Ecuador
  ECU2: 'Hernán Galíndez',
  ECU3: 'Gonzalo Valle',
  ECU4: 'Piero Hincapié',
  ECU5: 'Pervis Estupiñán',
  ECU6: 'Willian Pacho',
  ECU7: 'Ángelo Preciado',
  ECU8: 'Joel Ordóñez',
  ECU9: 'Moisés Caicedo',
  ECU10: 'Alan Franco',
  ECU11: 'Kendry Páez',
  ECU12: 'Pedro Vite',
  ECU14: 'John Yeboah',
  ECU15: 'Leonardo Campana',
  ECU16: 'Gonzalo Plata',
  ECU17: 'Nilson Angulo',
  ECU18: 'Alan Minda',
  ECU19: 'Kevin Rodríguez',
  ECU20: 'Enner Valencia',

  // Egypt
  EGY2: 'Mohamed El Shenawy',
  EGY3: 'Mohamed Hany',
  EGY4: 'Mohamed Hamdy',
  EGY5: 'Yasser Ibrahim',
  EGY6: 'Khaled Sobhi',
  EGY7: 'Ramy Rabia',
  EGY8: 'Hossam Abdelmaguid',
  EGY9: 'Ahmed Fatouh',
  EGY10: 'Marwan Attia',
  EGY11: 'Zizo',
  EGY12: 'Hamdy Fathy',
  EGY14: 'Mohamed Lasheen',
  EGY15: 'Emam Ashour',
  EGY16: 'Osama Faisal',
  EGY17: 'Mohamed Salah',
  EGY18: 'Mostafa Mohamed',
  EGY19: 'Trezeguet',
  EGY20: 'Omar Marmoush',

  // England
  ENG2: 'Jordan Pickford',
  ENG3: 'John Stones',
  ENG4: 'Marc Guéhi',
  ENG5: 'Ezri Konsa',
  ENG6: 'Trent Alexander-Arnold',
  ENG7: 'Reece James',
  ENG8: 'Dan Burn',
  ENG9: 'Jordan Henderson',
  ENG10: 'Declan Rice',
  ENG11: 'Jude Bellingham',
  ENG12: 'Cole Palmer',
  ENG14: 'Morgan Rogers',
  ENG15: 'Anthony Gordon',
  ENG16: 'Phil Foden',
  ENG17: 'Bukayo Saka',
  ENG18: 'Harry Kane',
  ENG19: 'Marcus Rashford',
  ENG20: 'Ollie Watkins',

  // Spain
  ESP2: 'Unai Simón',
  ESP3: 'Robin Le Normand',
  ESP4: 'Aymeric Laporte',
  ESP5: 'Dean Huijsen',
  ESP6: 'Pedro Porro',
  ESP7: 'Dani Carvajal',
  ESP8: 'Marc Cucurella',
  ESP9: 'Martín Zubimendi',
  ESP10: 'Rodri',
  ESP11: 'Pedri',
  ESP12: 'Fabián Ruiz',
  ESP14: 'Mikel Merino',
  ESP15: 'Lamine Yamal',
  ESP16: 'Dani Olmo',
  ESP17: 'Nico Williams',
  ESP18: 'Ferran Torres',
  ESP19: 'Álvaro Morata',
  ESP20: 'Mikel Oyarzabal',

  // France
  FRA2: 'Mike Maignan',
  FRA3: 'Théo Hernández',
  FRA4: 'William Saliba',
  FRA5: 'Jules Koundé',
  FRA6: 'Ibrahima Konaté',
  FRA7: 'Dayot Upamecano',
  FRA8: 'Lucas Digne',
  FRA9: 'Aurélien Tchouaméni',
  FRA10: 'Eduardo Camavinga',
  FRA11: 'Manu Koné',
  FRA12: 'Adrien Rabiot',
  FRA14: 'Michael Olise',
  FRA15: 'Ousmane Dembélé',
  FRA16: 'Bradley Barcola',
  FRA17: 'Désiré Doué',
  FRA18: 'Kingsley Coman',
  FRA19: 'Hugo Ekitiké',
  FRA20: 'Kylian Mbappé',

  // Germany
  GER2: 'Marc-André ter Stegen',
  GER3: 'Jonathan Tah',
  GER4: 'David Raum',
  GER5: 'Nico Schlotterbeck',
  GER6: 'Antonio Rüdiger',
  GER7: 'Waldemar Anton',
  GER8: 'Ridle Baku',
  GER9: 'Maximilian Mittelstädt',
  GER10: 'Joshua Kimmich',
  GER11: 'Florian Wirtz',
  GER12: 'Felix Nmecha',
  GER14: 'Leon Goretzka',
  GER15: 'Jamal Musiala',
  GER16: 'Serge Gnabry',
  GER17: 'Kai Havertz',
  GER18: 'Leroy Sané',
  GER19: 'Karim Adeyemi',
  GER20: 'Nick Woltemade',

  // Ghana
  GHA2: 'Lawrence Ati Zigi',
  GHA3: 'Tariq Lamptey',
  GHA4: 'Mohammed Salisu',
  GHA5: 'Alidu Seidu',
  GHA6: 'Alexander Djiku',
  GHA7: 'Gideon Mensah',
  GHA8: 'Caleb Yirenkyi',
  GHA9: 'Abdul Issahaku Fatawu',
  GHA10: 'Thomas Partey',
  GHA11: 'Salis Abdul Samed',
  GHA12: 'Kamaldeen Sulemana',
  GHA14: 'Mohammed Kudus',
  GHA15: 'Iñaki Williams',
  GHA16: 'Jordan Ayew',
  GHA17: 'André Ayew',
  GHA18: 'Joseph Paintsil',
  GHA19: 'Osman Bukari',
  GHA20: 'Antoine Semenyo',

  // Haiti
  HAI2: 'Johny Placide',
  HAI3: 'Carlens Arcus',
  HAI4: 'Martin Expérience',
  HAI5: 'Jean-Kévin Duverne',
  HAI6: 'Ricardo Adé',
  HAI7: 'Duke Lacroix',
  HAI8: 'Garven Metusala',
  HAI9: 'Hannes Delcroix',
  HAI10: 'Leverton Pierre',
  HAI11: 'Danley Jean Jacques',
  HAI12: 'Jean-Ricner Bellegarde',
  HAI14: 'Christopher Attys',
  HAI15: 'Derrick Etienne Jr.',
  HAI16: 'Josué Casimir',
  HAI17: 'Ruben Providence',
  HAI18: 'Duckens Nazon',
  HAI19: 'Louicius Deedson',
  HAI20: 'Frantzdy Pierrot',

  // Iran
  IRN2: 'Alireza Beiranvand',
  IRN3: 'Morteza Pouraliganji',
  IRN4: 'Ehsan Hajsafi',
  IRN5: 'Milad Mohammadi',
  IRN6: 'Shojae Khalilzadeh',
  IRN7: 'Ramin Rezaeian',
  IRN8: 'Hossein Kanaani',
  IRN9: 'Sadegh Moharrami',
  IRN10: 'Saleh Hardani',
  IRN11: 'Saeed Ezatolahi',
  IRN12: 'Saman Ghoddos',
  IRN14: 'Omid Noorafkan',
  IRN15: 'Roozbeh Cheshmi',
  IRN16: 'Mohammad Mohebi',
  IRN17: 'Sardar Azmoun',
  IRN18: 'Mehdi Taremi',
  IRN19: 'Alireza Jahanbakhsh',
  IRN20: 'Ali Gholizadeh',

  // Iraq
  IRQ2: 'Jalal Hassan',
  IRQ3: 'Rebin Sulaka',
  IRQ4: 'Hussein Ali',
  IRQ5: 'Akam Hashem',
  IRQ6: 'Merchas Doski',
  IRQ7: 'Zaid Tahseen',
  IRQ8: 'Manaf Younis',
  IRQ9: 'Zidane Iqbal',
  IRQ10: 'Amir Al-Ammari',
  IRQ11: 'Ibrahim Bayesh',
  IRQ12: 'Ali Jasim',
  IRQ14: 'Youssef Amyn',
  IRQ15: 'Aymen Sher',
  IRQ16: 'Marko Farji',
  IRQ17: 'Osama Rashid',
  IRQ18: 'Ali Al-Hamadi',
  IRQ19: 'Aymen Hussein',
  IRQ20: 'Mohanad Ali',

  // Ivory Coast
  CIV2: 'Yahia Fofana',
  CIV3: 'Ghislain Konan',
  CIV4: 'Wilfried Singo',
  CIV5: 'Odilon Kossounou',
  CIV6: 'Evan Ndicka',
  CIV7: 'Willy Boly',
  CIV8: 'Emmanuel Agbadou',
  CIV9: 'Ousmane Diomandé',
  CIV10: 'Franck Kessié',
  CIV11: 'Seko Fofana',
  CIV12: 'Ibrahim Sangaré',
  CIV14: 'Jean-Philippe Gbamin',
  CIV15: 'Amad Diallo',
  CIV16: 'Sébastien Haller',
  CIV17: 'Simon Adingra',
  CIV18: 'Yan Diomandé',
  CIV19: 'Evann Guessand',
  CIV20: 'Oumar Diakité',

  // Japan (codigo interno JAP, NO JPN)
  JAP2: 'Zion Suzuki',
  JAP3: 'Henry Heroki Mochizuki',
  JAP4: 'Ayumu Seko',
  JAP5: 'Junnosuke Suzuki',
  JAP6: 'Shogo Taniguchi',
  JAP7: 'Tsuyoshi Watanabe',
  JAP8: 'Kaishu Sano',
  JAP9: 'Yuki Soma',
  JAP10: 'Ao Tanaka',
  JAP11: 'Daichi Kamada',
  JAP12: 'Takefusa Kubo',
  JAP14: 'Ritsu Doan',
  JAP15: 'Keito Nakamura',
  JAP16: 'Takumi Minamino',
  JAP17: 'Shuto Machino',
  JAP18: 'Junya Ito',
  JAP19: 'Koki Ogawa',
  JAP20: 'Ayase Ueda',

  // Jordan
  JOR2: 'Yazeed Abulaila',
  JOR3: 'Ihsan Haddad',
  JOR4: 'Mohammad Abu Hashish',
  JOR5: 'Yazan Al-Arab',
  JOR6: 'Abdallah Nasib',
  JOR7: 'Saleem Obaid',
  JOR8: 'Mohammad Abualnadi',
  JOR9: 'Ibrahim Saadeh',
  JOR10: 'Nizar Al-Rashdan',
  JOR11: 'Noor Al-Rawabdeh',
  JOR12: 'Mohannad Abu Taha',
  JOR14: 'Amer Jamous',
  JOR15: 'Mousa Al-Taamari',
  JOR16: 'Yazan Al-Naimat',
  JOR17: 'Mahmoud Al-Mardi',
  JOR18: 'Ali Olwan',
  JOR19: 'Mohammad Abu Zrayq',
  JOR20: 'Ibrahim Sabra',

  // Korea Republic
  KOR2: 'Hyeon-woo Jo',
  KOR3: 'Seung-Gyu Kim',
  KOR4: 'Min-jae Kim',
  KOR5: 'Yu-min Cho',
  KOR6: 'Young-woo Seol',
  KOR7: 'Han-beom Lee',
  KOR8: 'Tae-seok Lee',
  KOR9: 'Myung-jae Lee',
  KOR10: 'Jae-sung Lee',
  KOR11: 'In-beom Hwang',
  KOR12: 'Kang-in Lee',
  KOR14: 'Seung-ho Paik',
  KOR15: 'Jens Castrop',
  KOR16: 'Dong-gyeong Lee',
  KOR17: 'Gue-sung Cho',
  KOR18: 'Heung-min Son',
  KOR19: 'Hee-chan Hwang',
  KOR20: 'Hyeon-Gyu Oh',

  // Saudi Arabia
  KSA2: 'Nawaf Al-Aqidi',
  KSA3: 'Abdulrahman Al-Sanbi',
  KSA4: 'Saud Abdulhamid',
  KSA5: 'Nawaf Boushal',
  KSA6: 'Jihad Thakri',
  KSA7: 'Moteb Al-Harbi',
  KSA8: 'Hassan Al-Tambakti',
  KSA9: 'Musab Al-Juwayr',
  KSA10: 'Ziyad Al-Johani',
  KSA11: 'Abdullah Al-Khaibari',
  KSA12: 'Nasser Al-Dawsari',
  KSA14: 'Saleh Abu Al-Shamat',
  KSA15: 'Marwan Al-Sahafi',
  KSA16: 'Salem Al-Dawsari',
  KSA17: 'Abdulrahman Al-Aboud',
  KSA18: 'Feras Al-Brikan',
  KSA19: 'Saleh Al-Shehri',
  KSA20: 'Abdullah Al-Hamdan',

  // Mexico
  MEX2: 'Luis Malagón',
  MEX3: 'Johan Vásquez',
  MEX4: 'Jorge Sánchez',
  MEX5: 'César Montes',
  MEX6: 'Jesús Gallardo',
  MEX7: 'Israel Reyes',
  MEX8: 'Diego Lainez',
  MEX9: 'Carlos Rodríguez',
  MEX10: 'Edson Álvarez',
  MEX11: 'Orbelín Pineda',
  MEX12: 'Marcel Ruiz',
  MEX14: 'Érick Sánchez',
  MEX15: 'Hirving Lozano',
  MEX16: 'Santiago Giménez',
  MEX17: 'Raúl Jiménez',
  MEX18: 'Alexis Vega',
  MEX19: 'Roberto Alvarado',
  MEX20: 'César Huerta',

  // Morocco
  MAR2: 'Yassine Bounou',
  MAR3: 'Munir El Kajoui',
  MAR4: 'Achraf Hakimi',
  MAR5: 'Noussair Mazraoui',
  MAR6: 'Nayef Aguerd',
  MAR7: 'Romain Saïss',
  MAR8: 'Jawad El Yamiq',
  MAR9: 'Adam Masina',
  MAR10: 'Sofyan Amrabat',
  MAR11: 'Azzedine Ounahi',
  MAR12: 'Eliesse Ben Seghir',
  MAR14: 'Bilal El Khannouss',
  MAR15: 'Ismael Saibari',
  MAR16: 'Youssef En-Nesyri',
  MAR17: 'Abde Ezzalzouli',
  MAR18: 'Soufiane Rahimi',
  MAR19: 'Brahim Díaz',
  MAR20: 'Ayoub El Kaabi',

  // Netherlands
  NED2: 'Bart Verbruggen',
  NED3: 'Virgil van Dijk',
  NED4: 'Micky van de Ven',
  NED5: 'Jurriën Timber',
  NED6: 'Denzel Dumfries',
  NED7: 'Nathan Aké',
  NED8: 'Jeremie Frimpong',
  NED9: 'Jan Paul van Hecke',
  NED10: 'Tijjani Reijnders',
  NED11: 'Ryan Gravenberch',
  NED12: 'Teun Koopmeiners',
  NED14: 'Frenkie de Jong',
  NED15: 'Xavi Simons',
  NED16: 'Justin Kluivert',
  NED17: 'Memphis Depay',
  NED18: 'Donyell Malen',
  NED19: 'Wout Weghorst',
  NED20: 'Cody Gakpo',

  // New Zealand
  NZL2: 'Max Crocombe',
  NZL3: 'Alex Paulsen',
  NZL4: 'Michael Boxall',
  NZL5: 'Liberato Cacace',
  NZL6: 'Tim Payne',
  NZL7: 'Tyler Bindon',
  NZL8: 'Francis de Vries',
  NZL9: 'Finn Surman',
  NZL10: 'Joe Bell',
  NZL11: 'Sarpreet Singh',
  NZL12: 'Ryan Thomas',
  NZL14: 'Matthew Garbett',
  NZL15: 'Marko Stamenić',
  NZL16: 'Ben Old',
  NZL17: 'Chris Wood',
  NZL18: 'Elijah Just',
  NZL19: 'Callum McCowatt',
  NZL20: 'Kosta Barbarouses',

  // Norway
  NOR2: 'Ørjan Nyland',
  NOR3: 'Julian Ryerson',
  NOR4: 'Leo Østigård',
  NOR5: 'Kristoffer Vassbakk Ajer',
  NOR6: 'Marcus Holmgren Pedersen',
  NOR7: 'David Møller Wolfe',
  NOR8: 'Torbjørn Heggem',
  NOR9: 'Morten Thorsby',
  NOR10: 'Martin Ødegaard',
  NOR11: 'Sander Berge',
  NOR12: 'Andreas Schjelderup',
  NOR14: 'Patrick Berg',
  NOR15: 'Erling Haaland',
  NOR16: 'Alexander Sørloth',
  NOR17: 'Aron Dønnum',
  NOR18: 'Jørgen Strand Larsen',
  NOR19: 'Antonio Nusa',
  NOR20: 'Oscar Bobb',

  // Panama
  PAN2: 'Orlando Mosquera',
  PAN3: 'Luis Mejía',
  PAN4: 'Fidel Escobar',
  PAN5: 'Andrés Andrade',
  PAN6: 'Michael Amir Murillo',
  PAN7: 'Eric Davis',
  PAN8: 'José Córdoba',
  PAN9: 'César Blackman',
  PAN10: 'Cristian Martínez',
  PAN11: 'Aníbal Godoy',
  PAN12: 'Adalberto Carrasquilla',
  PAN14: 'Édgar Bárcenas',
  PAN15: 'Carlos Harvey',
  PAN16: 'Ismael Díaz',
  PAN17: 'José Fajardo',
  PAN18: 'Cecilio Waterman',
  PAN19: 'José Luis Rodríguez',
  PAN20: 'Alberto Quintero',

  // Paraguay
  PAR2: 'Roberto Fernández',
  PAR3: 'Orlando Gill',
  PAR4: 'Gustavo Gómez',
  PAR5: 'Fabián Balbuena',
  PAR6: 'Juan José Cáceres',
  PAR7: 'Omar Alderete',
  PAR8: 'Junior Alonso',
  PAR9: 'Mathías Villasanti',
  PAR10: 'Diego Gómez',
  PAR11: 'Damián Bobadilla',
  PAR12: 'Andrés Cubas',
  PAR14: 'Matías Galarza Fonda',
  PAR15: 'Julio Enciso',
  PAR16: 'Alejandro Romero Gamarra',
  PAR17: 'Miguel Almirón',
  PAR18: 'Ramón Sosa',
  PAR19: 'Ángel Romero',
  PAR20: 'Antonio Sanabria',

  // Portugal
  POR2: 'Diogo Costa',
  POR3: 'José Sá',
  POR4: 'Rúben Dias',
  POR5: 'João Cancelo',
  POR6: 'Diogo Dalot',
  POR7: 'Nuno Mendes',
  POR8: 'Gonçalo Inácio',
  POR9: 'Bernardo Silva',
  POR10: 'Bruno Fernandes',
  POR11: 'Rúben Neves',
  POR12: 'Vitinha',
  POR14: 'João Neves',
  POR15: 'Cristiano Ronaldo',
  POR16: 'Francisco Trincão',
  POR17: 'João Félix',
  POR18: 'Gonçalo Ramos',
  POR19: 'Pedro Neto',
  POR20: 'Rafael Leão',

  // Qatar
  QAT2: 'Meshaal Barsham',
  QAT3: 'Sultan Albrake',
  QAT4: 'Lucas Mendes',
  QAT5: 'Homam Ahmed',
  QAT6: 'Boualem Khoukhi',
  QAT7: 'Pedro Miguel',
  QAT8: 'Tarek Salman',
  QAT9: 'Mohamed Al-Mannai',
  QAT10: 'Karim Boudiaf',
  QAT11: 'Assim Madibo',
  QAT12: 'Ahmed Fatehi',
  QAT14: 'Mohammed Waad',
  QAT15: 'Abdulaziz Hatem',
  QAT16: 'Hassan Al-Haydos',
  QAT17: 'Edmilson Junior',
  QAT18: 'Akram Hassan Afif',
  QAT19: 'Ahmed Al Ganehi',
  QAT20: 'Almoez Ali',

  // Scotland
  SCO2: 'Angus Gunn',
  SCO3: 'Jack Hendry',
  SCO4: 'Kieran Tierney',
  SCO5: 'Aaron Hickey',
  SCO6: 'Andrew Robertson',
  SCO7: 'Scott McKenna',
  SCO8: 'John Souttar',
  SCO9: 'Anthony Ralston',
  SCO10: 'Grant Hanley',
  SCO11: 'Scott McTominay',
  SCO12: 'Billy Gilmour',
  SCO14: 'Lewis Ferguson',
  SCO15: 'Ryan Christie',
  SCO16: 'Kenny McLean',
  SCO17: 'John McGinn',
  SCO18: 'Lyndon Dykes',
  SCO19: 'Che Adams',
  SCO20: 'Ben Gannon-Doak',

  // Senegal
  SEN2: 'Édouard Mendy',
  SEN3: 'Yehvann Diouf',
  SEN4: 'Moussa Niakhaté',
  SEN5: 'Abdoulaye Seck',
  SEN6: 'Ismail Jakobs',
  SEN7: 'El Hadji Malick Diouf',
  SEN8: 'Kalidou Koulibaly',
  SEN9: 'Idrissa Gana Gueye',
  SEN10: 'Pape Matar Sarr',
  SEN11: 'Pape Gueye',
  SEN12: 'Habib Diarra',
  SEN14: 'Lamine Camara',
  SEN15: 'Sadio Mané',
  SEN16: 'Ismaïla Sarr',
  SEN17: 'Boulaye Dia',
  SEN18: 'Iliman Ndiaye',
  SEN19: 'Nicolas Jackson',
  SEN20: 'Krépin Diatta',

  // South Africa
  RSA2: 'Ronwen Williams',
  RSA3: 'Sipho Chaine',
  RSA4: 'Aubrey Modiba',
  RSA5: 'Samukele Kabini',
  RSA6: 'Mbekezeli Mbokazi',
  RSA7: 'Khulumani Ndamane',
  RSA8: 'Siyabonga Ngezana',
  RSA9: 'Khuliso Mudau',
  RSA10: 'Nkosinathi Sibisi',
  RSA11: 'Teboho Mokoena',
  RSA12: 'Thalente Mbatha',
  RSA14: 'Bathusi Aubaas',
  RSA15: 'Yaya Sithole',
  RSA16: 'Sipho Mbule',
  RSA17: 'Lyle Foster',
  RSA18: 'Iqraam Rayners',
  RSA19: 'Mohau Nkota',
  RSA20: 'Oswin Appollis',

  // Switzerland
  SUI2: 'Gregor Kobel',
  SUI3: 'Yvon Mvogo',
  SUI4: 'Manuel Akanji',
  SUI5: 'Ricardo Rodríguez',
  SUI6: 'Nico Elvedi',
  SUI7: 'Aurèle Amenda',
  SUI8: 'Silvan Widmer',
  SUI9: 'Granit Xhaka',
  SUI10: 'Denis Zakaria',
  SUI11: 'Remo Freuler',
  SUI12: 'Fabian Rieder',
  SUI14: 'Ardon Jashari',
  SUI15: 'Johan Manzambi',
  SUI16: 'Michel Aebischer',
  SUI17: 'Breel Embolo',
  SUI18: 'Rubén Vargas',
  SUI19: 'Dan Ndoye',
  SUI20: 'Zeki Amdouni',

  // Sweden
  SWE2: 'Viktor Johansson',
  SWE3: 'Isak Hien',
  SWE4: 'Gabriel Gudmundsson',
  SWE5: 'Emil Holm',
  SWE6: 'Victor Nilsson Lindelöf',
  SWE7: 'Gustaf Lagerbielke',
  SWE8: 'Lucas Bergvall',
  SWE9: 'Hugo Larsson',
  SWE10: 'Jesper Karlström',
  SWE11: 'Yasin Ayari',
  SWE12: 'Mattias Svanberg',
  SWE14: 'Daniel Svensson',
  SWE15: 'Ken Sema',
  SWE16: 'Roony Bardghji',
  SWE17: 'Dejan Kulusevski',
  SWE18: 'Anthony Elanga',
  SWE19: 'Alexander Isak',
  SWE20: 'Viktor Gyökeres',

  // Tunisia
  TUN2: 'Bechir Ben Saïd',
  TUN3: 'Aymen Dahmen',
  TUN4: 'Yan Valery',
  TUN5: 'Montassar Talbi',
  TUN6: 'Yassine Meriah',
  TUN7: 'Ali Abdi',
  TUN8: 'Dylan Bronn',
  TUN9: 'Ellyes Skhiri',
  TUN10: 'Aïssa Laïdouni',
  TUN11: 'Ferjani Sassi',
  TUN12: 'Mohamed Ali Ben Romdhane',
  TUN14: 'Hannibal Mejbri',
  TUN15: 'Elias Achouri',
  TUN16: 'Elias Saad',
  TUN17: 'Hazem Mastouri',
  TUN18: 'Ismaël Gharbi',
  TUN19: 'Sayfallah Ltaief',
  TUN20: 'Naïm Sliti',

  // Turkey
  TUR2: 'Uğurcan Çakır',
  TUR3: 'Mert Müldür',
  TUR4: 'Zeki Çelik',
  TUR5: 'Abdülkerim Bardakcı',
  TUR6: 'Çağlar Söyüncü',
  TUR7: 'Merih Demiral',
  TUR8: 'Ferdi Kadıoğlu',
  TUR9: 'Kaan Ayhan',
  TUR10: 'İsmail Yüksek',
  TUR11: 'Hakan Çalhanoğlu',
  TUR12: 'Orkun Kökçü',
  TUR14: 'Arda Güler',
  TUR15: 'İrfan Can Kahveci',
  TUR16: 'Yunus Akgün',
  TUR17: 'Can Uzun',
  TUR18: 'Barış Alper Yılmaz',
  TUR19: 'Kerem Aktürkoğlu',
  TUR20: 'Kenan Yıldız',

  // Uruguay
  URU2: 'Sergio Rochet',
  URU3: 'Santiago Mele',
  URU4: 'Ronald Araújo',
  URU5: 'José María Giménez',
  URU6: 'Sebastián Cáceres',
  URU7: 'Mathías Olivera',
  URU8: 'Guillermo Varela',
  URU9: 'Nahitan Nández',
  URU10: 'Federico Valverde',
  URU11: 'Giorgian de Arrascaeta',
  URU12: 'Rodrigo Bentancur',
  URU14: 'Manuel Ugarte',
  URU15: 'Nicolás de la Cruz',
  URU16: 'Maxi Araújo',
  URU17: 'Darwin Núñez',
  URU18: 'Federico Viñas',
  URU19: 'Rodrigo Aguirre',
  URU20: 'Facundo Pellistri',

  // United States
  USA2: 'Matt Freese',
  USA3: 'Chris Richards',
  USA4: 'Tim Ream',
  USA5: 'Mark McKenzie',
  USA6: 'Alex Freeman',
  USA7: 'Antonee Robinson',
  USA8: 'Tyler Adams',
  USA9: 'Tanner Tessmann',
  USA10: 'Weston McKennie',
  USA11: 'Christian Roldan',
  USA12: 'Timothy Weah',
  USA14: 'Diego Luna',
  USA15: 'Malik Tillman',
  USA16: 'Christian Pulisic',
  USA17: 'Brenden Aaronson',
  USA18: 'Ricardo Pepi',
  USA19: 'Haji Wright',
  USA20: 'Folarin Balogun',

  // Uzbekistan
  UZB2: 'Utkir Yusupov',
  UZB3: 'Farrukh Sayfiev',
  UZB4: 'Sherzod Nasrullaev',
  UZB5: 'Umar Eshmurodov',
  UZB6: 'Husniddin Aliqulov',
  UZB7: 'Rustamjon Ashurmatov',
  UZB8: 'Khojiakbar Alijonov',
  UZB9: 'Abdukodir Khusanov',
  UZB10: 'Odiljon Hamrobekov',
  UZB11: 'Otabek Shukurov',
  UZB12: 'Jamshid Iskanderov',
  UZB14: 'Azizbek Turgunboev',
  UZB15: 'Khojimat Erkinov',
  UZB16: 'Eldor Shomurodov',
  UZB17: 'Oston Urunov',
  UZB18: 'Jaloliddin Masharipov',
  UZB19: 'Igor Sergeev',
  UZB20: 'Abbosbek Fayzullaev',
};
